import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { SearchResults } from '@components/SearchResults/SearchResults'
import { WishlistDrawer } from '@components/WishlistDrawer/WishlistDrawer'
import { withAlgoliaSearch, withExchangeRates, withSkeletonTheme } from '@hocs'
import { withApollo } from '../hocs/withApollo'
import { withCategoriesGrid } from '../hocs/withCategoriesGrid'
import { withErrorBoundary } from '../hocs/withErrorBoundary'
import { withI18next } from '../hocs/withI18next'
import { withTheme } from '../hocs/withTheme'
import { withWishlist } from '../hocs/withWishlist'

export const renderSearch = (searchEl: HTMLElement | null) => {
  if (!searchEl) {
    return
  }

  // Wrap only SearchResults with Algolia to isolate InstantSearch context
  const SearchResultsWithAlgolia = pipe(SearchResults, withAlgoliaSearch)

  // Main app component that includes both drawer and search results
  const SearchApp = () => (
    <>
      <WishlistDrawer />
      <SearchResultsWithAlgolia />
    </>
  )

  // Wrap the entire app with global providers
  const SearchWrapper = pipe(
    SearchApp,
    withExchangeRates,
    withSkeletonTheme,
    withI18next,
    withApollo,
    withCategoriesGrid,
    withErrorBoundary,
    withTheme,
    withWishlist,
  )

  ReactDOM.createRoot(searchEl).render(<SearchWrapper />)
}
